module.exports = __webpack_public_path__ + "img/bingo-logo.3ff34b65.png";